module.exports = __webpack_public_path__ + "img/pantalla-1-1.8f832fd5.png";